import { IStyle, IToggleStyles } from '@fluentui/react';
import { FontWeights, IH2OTheme } from '@h2oai/ui-kit';

export interface IEditFeatureStyles {
  root?: IStyle;
  form?: IStyle;
  fields?: IStyle;
  subTitle?: IStyle;
  buttons?: IStyle;
}

export interface IEditFeatureClassNames {
  root: string;
  form: string;
  fields: string;
  subTitle: string;
  buttons: string;
}

export const editFeatureStylesDefault = (_theme: IH2OTheme): Partial<IEditFeatureStyles> => ({
  root: {
    flex: 1,
    height: '100%',
    paddingTop: 17,
  },
  form: { height: '100%', display: 'flex', flexDirection: 'column', minHeight: 0 },
  fields: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
  },
  subTitle: {
    fontWeight: FontWeights.semiBold,
  },
  buttons: { textAlign: 'right' },
});

export const toggleStylesEditFeature: Partial<IToggleStyles> = {
  root: {
    justifyContent: 'space-between',
    marginRight: '70%',
  },
};
